import { createUserToken } from "./phylloServiceAPIs";

class PhylloSDK {
  async openPhylloSDK(platformId = null) {
    let { sdk_token, phyllo_user_id } = await createUserToken();
    const config = {
      clientDisplayName: "DreamStar",
      environment: "sandbox",
      userId: phyllo_user_id,
      token: sdk_token,
      workPlatformId: platformId,
    };
    console.log(
      `Opening Phyllo SDK for platform ID: ${platformId || "All Platforms"}`
    );
    const phylloConnect = window.PhylloConnect.initialize(config);
    this.setupEventHandlers(phylloConnect);
    phylloConnect.open();
  }
  async connectPhyllo(platform) {
    console.log("platform", platform);
    if (!platform.id) {
      alert(
        platform?.name +
          "ID is not configured. Please add it to PLATFORM_IDS object."
      );
      console.warn(
        platform?.name + "ID missing. Add it to PLATFORM_IDS in phylloSDK.js"
      );
      return;
    }
    await this.openPhylloSDK(platform.phyllo_platform_id);
  }
  async connectAll() {
    await this.openPhylloSDK(null);
  }
  setupEventHandlers(phylloConnect) {
    phylloConnect.on(
      "accountConnected",
      (accountId, workplatformId, userId) => {
        console.log(
          `onAccountConnected: ${accountId}, ${workplatformId}, ${userId}`
        );
      }
    );
    phylloConnect.on(
      "accountDisconnected",
      (accountId, workplatformId, userId) => {
        window.location.reload();
        console.log(
          `onAccountDisconnected: ${accountId}, ${workplatformId}, ${userId}`
        );
      }
    );
    phylloConnect.on("tokenExpired", (userId) => {
      console.log(`onTokenExpired: ${userId}`);
      if (
        window.confirm("Your session has expired, but we can help you fix it")
      ) {
        localStorage.removeItem("PHYLLO_SDK_TOKEN");
        this.openPhylloSDK();
      } else {
        window.location.href = "/";
      }
    });
    phylloConnect.on("exit", (reason, userId) => {
      console.log(`onExit: ${reason}, ${userId}`);
      // alert("Phyllo SDK exit reason: " + reason);
      window.location.reload();
    });
    phylloConnect.on("connectionFailure", (reason, workplatformId, userId) => {
      console.log(
        `onConnectionFailure: ${reason}, ${workplatformId}, ${userId}`
      );
      alert("Platform connection failure reason: " + reason);
    });
  }
  updatePlatformId(platform, id) {
    this.PLATFORM_IDS[platform] = id;
    console.log(`Updated ${platform} ID to: ${id}`);
  }
}
export default PhylloSDK;
